(function () {
	'use strict';

	angular.module('mx.components').directive('mxCheckbox', function mxCheckboxDirective() {
		return new mx.components.FormControlBase(MxCheckboxCtrl, 'mx-checkbox/mx-checkbox.html');
	});

	MxCheckboxCtrl.$inject = ['$timeout', '$attrs'];

	function MxCheckboxCtrl($timeout, $attrs) {
		var vm = this;
		var model;
		vm.$onInit = function () {
			mx.components.FormControlControllerBase.call(vm, $timeout);

			model = !!vm.model;
			Object.defineProperty(vm, 'model', {
				get: function () {
					return model;
				},
				set: function (value) {
					setValue(value);
				},
			});

			function setValue(value) {
				value = !!value;
				if (model !== value) {
					model = value;
					$timeout(function () {
						vm.onChange({ value: model });
					});
				}
			}
		};

		vm.$postLink = function () {
			vm.tabindex = $attrs.tabindex || 0;
		};

		return vm;
	}
})();
